import React, { createRef } from 'react'
import queryString from 'query-string'
import { debounce as _debounce, isEqual as _isEqual, size as _size } from 'lodash'
import { 
    AiAnswer, 
    Message, 
    QuestionBtn, 
    UAHighcharts, 
    getCategoryType,
    updateChart,
} from 'components'
import { QAComponent } from '../QAComponent'
import chartFunc from 'modules/Dashboard/components/SinglePanel/chartFunc'
import { Cookies } from 'utils'
import 'assets/sass/Single/ai-chat.scss'
import 'assets/sass/utils/ai.scss'


export class AiChat extends React.PureComponent {
    constructor(props) {
        super(props);

        // Limit of requests
        const { singleKey, option } = props;
        const requestLimit = option.request_limit;
        
        let requestsRemaining = Cookies.get(`${singleKey}_remaining_requests`);

        const numRequestsRemaining = Number(requestsRemaining);

        if (typeof requestLimit !== 'undefined') {
            if (!requestsRemaining || (requestLimit === 'unlimited' && !isNaN(numRequestsRemaining)) 
                    || (!isNaN(requestLimit) && requestsRemaining === 'unlimited')
                    || requestLimit < numRequestsRemaining) {
                requestsRemaining = requestLimit;
                
                Cookies.set(
                    `${singleKey}_remaining_requests`,
                    requestLimit,
                    { path: '/', maxAge: 60 * 60 * 24 * 1, sameSite: 'Lax', secure: true }
                );
            } else {
                requestsRemaining = (requestsRemaining === 'unlimited') ? requestsRemaining : numRequestsRemaining;
            }
        }
        
        this.state = { input: '', remaining_requests: requestsRemaining, qa_temp: {} };
        this.ref = createRef();
    }

    onChange = (e) => {
        e.preventDefault();

        const { name, value } = e.target;

        this.setState({ [name]: value });
    }

    onQuestionSet = (e) => {
        e.preventDefault();

        const { actual, show, text } = e?.target?.dataset;
        const { input, remaining_requests } = this.state;
        const prompt = actual ?? input;
        const showUpdated = show ?? input;

        if (!prompt && prompt.length === 0) { return; }

        const { singleKey, category, option, onQuestionSet } = this.props;
        const requestLimit = option.request_limit;

        let canAsk = true;

        if (text) {
            // 直接顯示答案，不發送請求
            onQuestionSet({ show: showUpdated, prompt: actual, text: text });

            // canAsk = false;
        }

        let promptUpdated = prompt;

        if (category === 'industry') { promptUpdated = `產業:${prompt}`; }

        if (category === 'stock') { promptUpdated = `個股:${prompt}`; }
        
        if (typeof requestLimit !== 'undefined') {
            const remainingRequests = (remaining_requests === 'unlimited') ? remaining_requests : remaining_requests - 1;
            
            this.setState({ remaining_requests: remainingRequests });
            
            if (remainingRequests > -1) {
                Cookies.set(
                    `${singleKey}_remaining_requests`,
                    remainingRequests,
                    { path: '/', maxAge: 60 * 60 * 24 * 1, sameSite: 'Lax', secure: true }
                );
            } else {
                canAsk = false;
            }
        }
        
        if (canAsk) { 
            const qaTemp = { show: showUpdated, prompt: promptUpdated };
            
            this.setState(
                { qa_temp: qaTemp }, 
                () => {
                    onQuestionSet(qaTemp);
                    this.onSubmit();
                }
            );
        } else {
            Message.SmallBox({
                title   : '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> 本日提問次數已用完',
                content : '',
                timeout : 3000,
            });
        }
    }

    onKeyUp = (e) => {
        e.preventDefault();
        
        if (e.keyCode === 13) { 
			console.log(e.keyCode);
			return; 
		}
    }

    onSubmit = () => {
        const qaTemp = this.state.qa_temp;
        const { qa, ai_chat_loading, onQAAnswerGetRequest } = this.props;
        const qaUpdated = (_size(qaTemp) > 0) ? qaTemp : qa;
        
        if (ai_chat_loading) { return; }

        const inputRequest = queryString.stringify(qaUpdated, { arrayFormat: 'bracket' });
    
        this.setState(
            { input: '', qa_temp: {} },
            () => onQAAnswerGetRequest(inputRequest)
        );
    }

    onClear = () => this.props.onClear()

    renderChart = () => {
        const singleKey = this.props.singleKey;

        if (!document.getElementById(`ai-report-${singleKey}`)) { return; }

        const qa = this.props.qa;
        const text = qa.text ?? null;

        if (!text || !text.highchart || _size(text.highchart) === 0) { return; }

        const { is_mobile, colour_theme } = this.props;

        let options = text.highchart;
        options = {
            ...options,
            chart: { 
                ...options.chart, 
                stacking: chartFunc.checkStacking(options.chart.type),
                type: chartFunc.getChartStyle(options.chart.type),
            },
            exporting: { chartOptions: { plotOptions: { series: { dataLabels: {
                enabled: false,
            } } } } },
        };

        if (is_mobile) { options.title = { ...options.title, text: '' }; }

        const dateType = options.xAxis
            ?
            getCategoryType(options.xAxis.categories)
            :
            'day';

        options.exporting = { chartOptions: { plotOptions: { series: { dataLabels: {
            enabled: false,
        } } } } };
        
        if (!this.chart) {
            this.chart = UAHighcharts(
                `ai-report-${singleKey}`,
                options,
                dateType,
                false,
                false,
                false,
                true,
                colour_theme
            );
        } else {
            updateChart(
                this.chart,
                options,
                dateType,
                false,
                false,
                false,
                true,
                colour_theme
            );
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { 
            category, 
            qas, 
            qa,
            stock, 
            // width,
            // side_menu_hidden,
            // colour_theme,
            onQADataLoadRequest, 
            onReset,
        } = this.props;

        // if (!_isEqual(prevProps.qa, qa) && _size(qa) && !qa.text) { this.onSubmit(); }
        if (!_isEqual(prevProps.qa, qa) 
                // || prevProps.width !== width
                // || prevProps.side_menu_hidden !== side_menu_hidden
                // || !_isEqual(prevProps.colour_theme, colour_theme)
            ) {
            if (!_size(qa)) { return; }

            // if (!_isEqual(prevProps.qa, qa)) { this.chart = null; }
        
            if (!qa.text) {
                // this.setState({ submitted: true }, this.onSubmit);
            } else {
                this.renderChart();
            }
        }

        if ((!_isEqual(prevProps.qas, qas) && !_size(qas))
                || prevProps.stock.stock_code !== stock.stock_code) {
            onReset();

            if (category === 'AnnualReport') { onQADataLoadRequest(); }
        }
    }

    componentDidMount() {
        const { category, onQADataLoadRequest } = this.props;

        if (category === 'AnnualReport') { onQADataLoadRequest(); }
    }

    render() {
        const requestsRemaining = this.state.remaining_requests;
        const { 
            singleKey, 
            category, 
            subcategory, 
            ai_chat_loading, 
            qas, 
            qa,
            option, 
        } = this.props;
        const { questions, request_limit } = option;
        
        let notice = null;
        let requestLimit = null;
        let btnTitle = 'paper-plane';
        let component = null;
        
        if (!questions) {
            notice = (
                <label className='margin-vertical-10'>
                    警語：本套件功能為輔助蒐集資料。資料來源：法說會、公司管理階層、業內資訊、產業機構報告、優分析供應鏈調查、年報、財報， 不代表任何建議，也不保證資料正確性
                </label>
            );
        }

        if (typeof request_limit !== 'undefined') {
            let txt = '';

            switch (requestsRemaining) {
                case 0:
                    txt = '本日提問次數已用完';

                    break;

                // case 'unlimited':
                //  txt = '限時開放不限次數提問！';

                //  break;

                default:
                //  txt = `剩餘 ${requestsRemaining} / ${request_limit} 次`;

                    break;
            }

            requestLimit = <label className='margin-top-10 pull-right'>{txt}</label>;
        }

        const isThereQuestion = _size(qa) > 0;
        const btnDisabled = ai_chat_loading || requestsRemaining === 0;
        const onClick = _debounce(
            this.onQuestionSet,
            300,
            { leading: true, trailing: false }
        );
        const onKeyUp = _debounce(
            this.onKeyUp,
            100,
            { leading: true, trailing: false }
        );

        if (isThereQuestion) {
            component = ((category === 'industry' && qa.text?.highchart)
                ? (
                    <AiAnswer
                        type='Chat'
                        singleKey={singleKey}
                        category={category}
                        subcategory={subcategory}
                        loading={ai_chat_loading}
                        option={option}
                        onQuestionSet={onClick}
                    />
                )
                : (
                    <QAComponent
                        item={qa}
                        loading={ai_chat_loading}
                        disabled={btnDisabled}
                        onQuestionSet={onClick}
                    />
                )
            );
        }
        
        return (
            <div className={`ai-chat ${(category === 'industry' && qa.text?.highchart) ? 'ai' : ''}`}>
                <form className='ua-form' name='ai-form' onSubmit={e => e.preventDefault()}> 
                    <fieldset className='notice text-center'>
                        <section>
                            {notice}

                            {requestLimit}
                        </section>
                    </fieldset>

                    {(category !== 'default') && (
                        <fieldset className='question-inputs'>
                            <section className='inputs d-flex align-items-center'>
                                <input
                                    ref={this.ref}
                                    type='text'
                                    name='input'
                                    className='question-input ua-input'
                                    value={this.state.input}
                                    placeholder='請直接提問'
                                    onChange={this.onChange}
                                    onKeyUp={onKeyUp}
                                />

                                <button
                                    type='button'
                                    className={`question-submit submit ua-btn default
                                            ${(btnDisabled || this.state.input.length === 0) ? 'disabled' : ''}`}
                                    disabled={btnDisabled}
                                    onClick={onClick}
                                >
                                    <i className={`fa fa-${btnTitle}`} />
                                </button>
                            </section>
                        </fieldset>
                    )}

                    <fieldset className='questions'>
                        <section className='btn-container text-center'>
                            {qas.map((q, idx) => {
                                const { show, prompt, text } = q;

                                return (show
                                    ? (
                                        <QuestionBtn
                                            actual={prompt}
                                            btnText={show}
                                            currShow={show}
                                            disabled={btnDisabled}
                                            text={text}
                                            value={qa?.show}
                                            onClick={onClick}
                                            key={idx}
                                        />
                                    )
                                    : null
                                );
                            })}

                            {(isThereQuestion && !ai_chat_loading) && (
                                <div className='questions-clear-btn' onClick={this.onClear}>
                                    清除回答
                                </div>
                            )}
                        </section>
                    </fieldset>

                    {isThereQuestion && (
                        <fieldset className='answers'>
                            {component}

                            {ai_chat_loading && (
                                <div>
                                    回答中...

                                    <div className='content-loader'/>
                                </div>
                            )}
                        </fieldset>
                    )}
                </form>
            </div>
        );
    }
}
